export enum ValidationIssue {
  Medarbejder,
  Validering,
}

export type ValidationIssueItem = {
  text: string;
  validationIssue: ValidationIssue;
};
